module.exports = __webpack_public_path__ + "static/media/ruler-horizontal.1bf8f14e.svg";